import {
    Container,
    Title,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/ProgressBarSection/ProgressBarSection.styled";
import ProgressBar from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/ProgressBarSection/ProgressBar/ProgressBar";
import { i18nFilter } from "app/filters/i18nFilter";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";

interface IProgressBarSectionProps {
    packages: IPackage[];
    invitationCount: number;
}

const ProgressBarSection = ({ invitationCount, packages }: IProgressBarSectionProps) => {
    const i18n = i18nFilter();

    return (
        <Container data-automation="progress-bar-section">
            <Title>{i18n("rewards_modal.main_screen.progress_bar.title")}</Title>
            <ProgressBar
                packages={packages}
                invitationCount={invitationCount}
            />
        </Container>
    );
};

export default ProgressBarSection;
